//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { of as _observableOf, throwError as _observableThrow, Observable } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IDeliveryAddressClient {
  /**
   * Creates a new delivery address.
   * @param deliveryAddress Content of the delivery address to create.
   * @return 201 Created if the address was created successfully.
   */
  create(deliveryAddress: ApiDeliveryAddress): Observable<FileResponse>;
  /**
   * Retrieves all delivery addresses of the current general contractor.
   * @param type (optional) Type of the addresses to retrieve.
   * @return A list of all available delivery addresses.
   */
  getAll(type: AddressType | null | undefined): Observable<ApiDeliveryAddress[]>;
  /**
   * Deletes an existing delivery address.
   * @param id Id of the address to delete.
   * @return 204 NoContent if the delivery address was successfully deleted or 404 NotFound if an address with the specified id does not exist.
   */
  delete(id: string): Observable<void>;
  /**
   * Retrieves a single delivery address.
   * @param id Id of the address to retrieve.
   * @return 200 Ok and the address with the requested id or 404 NotFound if no address with the requested id was found.
   */
  get(id: string): Observable<ApiDeliveryAddress>;
  /**
   * Updates a delivery address.
   * @param id ID of the address to update.
   * @param deliveryAddress New content of the address.
   * @return 204 NoContent if the address was updated successfully
   */
  update(id: string, deliveryAddress: ApiDeliveryAddress): Observable<void>;
}

@Injectable()
export class DeliveryAddressClient implements IDeliveryAddressClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Creates a new delivery address.
   * @param deliveryAddress Content of the delivery address to create.
   * @return 201 Created if the address was created successfully.
   */
  create(deliveryAddress: ApiDeliveryAddress): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/DeliveryAddress';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(deliveryAddress);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all delivery addresses of the current general contractor.
   * @param type (optional) Type of the addresses to retrieve.
   * @return A list of all available delivery addresses.
   */
  getAll(type: AddressType | null | undefined): Observable<ApiDeliveryAddress[]> {
    let url_ = this.baseUrl + '/api/DeliveryAddress?';
    if (type !== undefined && type !== null) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiDeliveryAddress[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiDeliveryAddress[]>;
        })
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<ApiDeliveryAddress[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiDeliveryAddress[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Deletes an existing delivery address.
   * @param id Id of the address to delete.
   * @return 204 NoContent if the delivery address was successfully deleted or 404 NotFound if an address with the specified id does not exist.
   */
  delete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/DeliveryAddress/{id}';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a single delivery address.
   * @param id Id of the address to retrieve.
   * @return 200 Ok and the address with the requested id or 404 NotFound if no address with the requested id was found.
   */
  get(id: string): Observable<ApiDeliveryAddress> {
    let url_ = this.baseUrl + '/api/DeliveryAddress/{id}';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiDeliveryAddress>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiDeliveryAddress>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiDeliveryAddress> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiDeliveryAddress);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates a delivery address.
   * @param id ID of the address to update.
   * @param deliveryAddress New content of the address.
   * @return 204 NoContent if the address was updated successfully
   */
  update(id: string, deliveryAddress: ApiDeliveryAddress): Observable<void> {
    let url_ = this.baseUrl + '/api/DeliveryAddress/{id}';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(deliveryAddress);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IDemoClient {
  /**
   * Resets or generates data for demonstration purposes on all supported repositories.
   * @return A task that represents the asynchronous operation. The value of its Result property contains the api action result.
   */
  resetDemoData(): Observable<void>;
}

@Injectable()
export class DemoClient implements IDemoClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Resets or generates data for demonstration purposes on all supported repositories.
   * @return A task that represents the asynchronous operation. The value of its Result property contains the api action result.
   */
  resetDemoData(): Observable<void> {
    let url_ = this.baseUrl + '/api/Demo';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetDemoData(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetDemoData(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processResetDemoData(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IDocumentClient {
  /**
   * Uploads a document to a configured storage.
   * @param projectId Id of the project the document belongs to.
   * @param content (optional) Content of the file.
   * @param documentType (optional) Type of the document to upload.
   * @return 201 Created if the document was successfully uploaded or 404 if a project with the specified id does not exist.
   */
  create(
    projectId: string,
    content: FileParameter | undefined,
    documentType: string | undefined
  ): Observable<void>;
  /**
   * Retrieves a list of all documents of a project.
   * @param projectId Id of the project to retrieve documents for.
   * @return A list of documents belonging to the project or 404 if a project with the specified id does not exist.
   */
  getList(projectId: string): Observable<Document[]>;
  /**
   * Retrieves the content of a document.
   * @param projectId Id of the project the document belongs to.
   * @param documentId Id of the document.
   * @return The binary content of the document or 404 if no project with the specified id or document within this project exists.
   */
  getContent(projectId: string, documentId: string): Observable<FileResponse>;
  /**
   * Retrieves mandatory documents of a project.
   * @param projectId Id of the project the mandatory documents belong to.
   * @return A list of mandatory documents belonging to the project or 404 if a project with the specified id does not exist.
   */
  getMandatory(projectId: string): Observable<ApiMandatoryDocument[]>;
  /**
     * Deletes the specified document from the given project.
     * @param projectId The unique identifier of the project containing the document to delete. Cannot be null or empty.
     * @param documentId The unique identifier of the document to delete. Cannot be null or empty.
     * @return An IActionResult that returns Status204NoContent if the document is
                successfully deleted, or Status404NotFound if the document does not exist.
     */
  delete(projectId: string, documentId: string): Observable<void>;
}

@Injectable()
export class DocumentClient implements IDocumentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Uploads a document to a configured storage.
   * @param projectId Id of the project the document belongs to.
   * @param content (optional) Content of the file.
   * @param documentType (optional) Type of the document to upload.
   * @return 201 Created if the document was successfully uploaded or 404 if a project with the specified id does not exist.
   */
  create(
    projectId: string,
    content: FileParameter | undefined,
    documentType: string | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/project/{projectId}/documents';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (content === null || content === undefined)
      throw new globalThis.Error("The parameter 'content' cannot be null.");
    else content_.append('Content', content.data, content.fileName ? content.fileName : 'Content');
    if (documentType === null || documentType === undefined)
      throw new globalThis.Error("The parameter 'documentType' cannot be null.");
    else content_.append('DocumentType', documentType.toString());

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a list of all documents of a project.
   * @param projectId Id of the project to retrieve documents for.
   * @return A list of documents belonging to the project or 404 if a project with the specified id does not exist.
   */
  getList(projectId: string): Observable<Document[]> {
    let url_ = this.baseUrl + '/api/project/{projectId}/documents';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Document[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Document[]>;
        })
      );
  }

  protected processGetList(response: HttpResponseBase): Observable<Document[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as Document[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves the content of a document.
   * @param projectId Id of the project the document belongs to.
   * @param documentId Id of the document.
   * @return The binary content of the document or 404 if no project with the specified id or document within this project exists.
   */
  getContent(projectId: string, documentId: string): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/project/{projectId}/documents/{documentId}/content';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (documentId === undefined || documentId === null)
      throw new globalThis.Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContent(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetContent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processGetContent(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves mandatory documents of a project.
   * @param projectId Id of the project the mandatory documents belong to.
   * @return A list of mandatory documents belonging to the project or 404 if a project with the specified id does not exist.
   */
  getMandatory(projectId: string): Observable<ApiMandatoryDocument[]> {
    let url_ = this.baseUrl + '/api/project/{projectId}/documents/mandatory';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMandatory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMandatory(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiMandatoryDocument[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiMandatoryDocument[]>;
        })
      );
  }

  protected processGetMandatory(response: HttpResponseBase): Observable<ApiMandatoryDocument[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiMandatoryDocument[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Deletes the specified document from the given project.
     * @param projectId The unique identifier of the project containing the document to delete. Cannot be null or empty.
     * @param documentId The unique identifier of the document to delete. Cannot be null or empty.
     * @return An IActionResult that returns Status204NoContent if the document is
                successfully deleted, or Status404NotFound if the document does not exist.
     */
  delete(projectId: string, documentId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/project/{projectId}/documents/{documentId}';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (documentId === undefined || documentId === null)
      throw new globalThis.Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IEquipmentClient {
  /**
   * Creates an equipment.
   * @param projectId ID of the project the equipment belongs to.
   * @param equipment An equipment that should be created.
   * @return 204 NoContent if the equipment was created successfully or 404 NotFound if the specified project does not exist.
   */
  create(projectId: string, equipment: Equipment): Observable<void>;
  /**
     * Retrieves all equipments connected to a project.
     * @param projectId ID of the project the equipments belong to.
     * @return 200 Ok with a list of all equipments that belong to the specified project or 404 if a preoject with the
    specified id does not exist.
     */
  get(projectId: string): Observable<Equipment[]>;
  /**
   * Updates a list of equipments.
   * @param projectId ID of the project the equipments belong to.
   * @param request The update request containing equipments and an optional age justification.
   * @return 204 NoContent if the equipments were updated successfully or 404 NotFound if the specified project does not exist.
   */
  update(projectId: string, request: ApiEquipmentUpdateRequest): Observable<void>;
}

@Injectable()
export class EquipmentClient implements IEquipmentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Creates an equipment.
   * @param projectId ID of the project the equipment belongs to.
   * @param equipment An equipment that should be created.
   * @return 204 NoContent if the equipment was created successfully or 404 NotFound if the specified project does not exist.
   */
  create(projectId: string, equipment: Equipment): Observable<void> {
    let url_ = this.baseUrl + '/api/project/{projectId}/equipments/CreateAsync';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(equipment);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Retrieves all equipments connected to a project.
     * @param projectId ID of the project the equipments belong to.
     * @return 200 Ok with a list of all equipments that belong to the specified project or 404 if a preoject with the
    specified id does not exist.
     */
  get(projectId: string): Observable<Equipment[]> {
    let url_ = this.baseUrl + '/api/project/{projectId}/equipments';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Equipment[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Equipment[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<Equipment[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as Equipment[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates a list of equipments.
   * @param projectId ID of the project the equipments belong to.
   * @param request The update request containing equipments and an optional age justification.
   * @return 204 NoContent if the equipments were updated successfully or 404 NotFound if the specified project does not exist.
   */
  update(projectId: string, request: ApiEquipmentUpdateRequest): Observable<void> {
    let url_ = this.baseUrl + '/api/project/{projectId}/equipments';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IFinalMeasurementClient {
  /**
   * Completes a final measurement.
   * @param projectId Id of the project the final measurement belongs to.
   * @param reason (optional) Text explaining why a final measurement was accepted due to additional positions.
   * @return 204 NoContent if the final measurement was created successfully.
   */
  complete(projectId: string, reason: string | null | undefined): Observable<void>;
  /**
   * Creates a final measurement for a project.
   * @param projectId Id of the project the final measurement belongs to.
   * @param finalMeasurement Contents of the final measurement to create.
   * @return 204 NoContent if the final measurement was created successfully.
   */
  create(projectId: string, finalMeasurement: ApiOffer): Observable<ApiSaveHintsResponse>;
  /**
   * Retrieves a final measurement for a project.
   * @param projectId Id of the project the final measurement belongs to.
   * @return 200 OK or 404 NotFound if no matching final measurement was found.
   */
  get(projectId: string): Observable<ApiOffer>;
  /**
     * Updates an existing final measurement.
     * @param projectId Id of the project the final measurement belongs to.
     * @param finalMeasurement The final measurement to update.
     * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or the specified object
    does not exist.
     */
  update(projectId: string, finalMeasurement: ApiOffer): Observable<ApiSaveHintsResponse>;
  /**
   * Initiates creation of a final measurement early in the proces.
   * @param projectId Id of the project final measurement creation should be initiated.
   * @param serviceAcceptanceDate (optional) Date of the service acceptance.
   * @param serviceAcceptanceDocument (optional) Service acceptance document.
   * @param defectsFixed (optional) True if the service acceptance had defects that have been fixed or false if no defects where reported on service acceptance.
   * @return A task that represents the asynchronous operation. The value of its Result property contains the api action result.
   */
  initiateFinalMeasurement(
    projectId: string,
    serviceAcceptanceDate: Date | undefined,
    serviceAcceptanceDocument: FileParameter | undefined,
    defectsFixed: boolean | undefined
  ): Observable<void>;
}

@Injectable()
export class FinalMeasurementClient implements IFinalMeasurementClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Completes a final measurement.
   * @param projectId Id of the project the final measurement belongs to.
   * @param reason (optional) Text explaining why a final measurement was accepted due to additional positions.
   * @return 204 NoContent if the final measurement was created successfully.
   */
  complete(projectId: string, reason: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/FinalMeasurement/complete?';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (reason !== undefined && reason !== null)
      url_ += 'reason=' + encodeURIComponent('' + reason) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processComplete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processComplete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processComplete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates a final measurement for a project.
   * @param projectId Id of the project the final measurement belongs to.
   * @param finalMeasurement Contents of the final measurement to create.
   * @return 204 NoContent if the final measurement was created successfully.
   */
  create(projectId: string, finalMeasurement: ApiOffer): Observable<ApiSaveHintsResponse> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/FinalMeasurement';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(finalMeasurement);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiSaveHintsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiSaveHintsResponse>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<ApiSaveHintsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiSaveHintsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      // Manually patched (see Task-30813): the backend now always returns 200 OK with an
      // ApiSaveHintsResponse body for this operation, never 204 — NSwag cannot model two success
      // status codes on one operation. Treat a 204 as an empty-hints success rather than throwing,
      // as a safety net in case an older backend deployment is still returning it during rollout.
      return _observableOf(null as any as ApiSaveHintsResponse);
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a final measurement for a project.
   * @param projectId Id of the project the final measurement belongs to.
   * @return 200 OK or 404 NotFound if no matching final measurement was found.
   */
  get(projectId: string): Observable<ApiOffer> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/FinalMeasurement';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiOffer>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiOffer>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiOffer> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiOffer);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Updates an existing final measurement.
     * @param projectId Id of the project the final measurement belongs to.
     * @param finalMeasurement The final measurement to update.
     * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or the specified object
    does not exist.
     */
  update(projectId: string, finalMeasurement: ApiOffer): Observable<ApiSaveHintsResponse> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/FinalMeasurement';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(finalMeasurement);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiSaveHintsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiSaveHintsResponse>;
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<ApiSaveHintsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiSaveHintsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      // Manually patched (see Task-30813): the backend now always returns 200 OK with an
      // ApiSaveHintsResponse body for this operation, never 204 — NSwag cannot model two success
      // status codes on one operation. Treat a 204 as an empty-hints success rather than throwing,
      // as a safety net in case an older backend deployment is still returning it during rollout.
      return _observableOf(null as any as ApiSaveHintsResponse);
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Initiates creation of a final measurement early in the proces.
   * @param projectId Id of the project final measurement creation should be initiated.
   * @param serviceAcceptanceDate (optional) Date of the service acceptance.
   * @param serviceAcceptanceDocument (optional) Service acceptance document.
   * @param defectsFixed (optional) True if the service acceptance had defects that have been fixed or false if no defects where reported on service acceptance.
   * @return A task that represents the asynchronous operation. The value of its Result property contains the api action result.
   */
  initiateFinalMeasurement(
    projectId: string,
    serviceAcceptanceDate: Date | undefined,
    serviceAcceptanceDocument: FileParameter | undefined,
    defectsFixed: boolean | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/FinalMeasurement/initiate';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (serviceAcceptanceDate === null || serviceAcceptanceDate === undefined)
      throw new globalThis.Error("The parameter 'serviceAcceptanceDate' cannot be null.");
    else content_.append('ServiceAcceptanceDate', serviceAcceptanceDate.toJSON());
    if (serviceAcceptanceDocument === null || serviceAcceptanceDocument === undefined)
      throw new globalThis.Error("The parameter 'serviceAcceptanceDocument' cannot be null.");
    else
      content_.append(
        'ServiceAcceptanceDocument',
        serviceAcceptanceDocument.data,
        serviceAcceptanceDocument.fileName
          ? serviceAcceptanceDocument.fileName
          : 'ServiceAcceptanceDocument'
      );
    if (defectsFixed === null || defectsFixed === undefined)
      throw new globalThis.Error("The parameter 'defectsFixed' cannot be null.");
    else content_.append('DefectsFixed', defectsFixed.toString());

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInitiateFinalMeasurement(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInitiateFinalMeasurement(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processInitiateFinalMeasurement(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IGeneralAgreementClient {
  /**
   * Retrieves the general agreement for the current general contractor.
   * @param projectId (optional) The ID of the project to retrieve the general agreement for.
   * @return A hierarchy containing all available services.
   */
  get(projectId: string | undefined): Observable<ApiGeneralAgreementNode[]>;
}

@Injectable()
export class GeneralAgreementClient implements IGeneralAgreementClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Retrieves the general agreement for the current general contractor.
   * @param projectId (optional) The ID of the project to retrieve the general agreement for.
   * @return A hierarchy containing all available services.
   */
  get(projectId: string | undefined): Observable<ApiGeneralAgreementNode[]> {
    let url_ = this.baseUrl + '/api/GeneralAgreement?';
    if (projectId === null) throw new globalThis.Error("The parameter 'projectId' cannot be null.");
    else if (projectId !== undefined)
      url_ += 'projectId=' + encodeURIComponent('' + projectId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiGeneralAgreementNode[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiGeneralAgreementNode[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiGeneralAgreementNode[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiGeneralAgreementNode[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IGeneralContractorClient {
  /**
   * Retrieves a single general contractor by its ID / number.
   * @param id (optional) ID of the general contractor to retrieve.
   * @return The requested general contractor.
   */
  get(id: string | undefined): Observable<GeneralContractor>;
}

@Injectable()
export class GeneralContractorClient implements IGeneralContractorClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Retrieves a single general contractor by its ID / number.
   * @param id (optional) ID of the general contractor to retrieve.
   * @return The requested general contractor.
   */
  get(id: string | undefined): Observable<GeneralContractor> {
    let url_ = this.baseUrl + '/api/GeneralContractor?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GeneralContractor>;
            }
          } else return _observableThrow(response_) as any as Observable<GeneralContractor>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GeneralContractor> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GeneralContractor);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IInfoDocumentClient {
  /**
     * Uploads a new informational document.
     * @param content (optional) Content of the file.
     * @param description (optional) Free description of the document.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  createInfoDocument(
    content: FileParameter | undefined,
    description: string | null | undefined
  ): Observable<FileResponse | null>;
  /**
     * Deletes an informational document.
     * @param id (optional) ID of the document to delete.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  delete(id: string | undefined): Observable<void>;
  /**
     * Retrieves a list of available informational documents.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  getInfoDocuments(): Observable<ApiInfoDocument[]>;
  /**
     * Retrieves a link where to download content of a document.
     * @param id ID of the document a download link is requested for.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  getDownloadLink(id: string): Observable<string>;
  /**
     * Retrieves the content of an informational document.
     * @param id ID of the document to retrieve.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  getContent(id: string): Observable<FileResponse>;
}

@Injectable()
export class InfoDocumentClient implements IInfoDocumentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
     * Uploads a new informational document.
     * @param content (optional) Content of the file.
     * @param description (optional) Free description of the document.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  createInfoDocument(
    content: FileParameter | undefined,
    description: string | null | undefined
  ): Observable<FileResponse | null> {
    let url_ = this.baseUrl + '/api/info/documents';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (content === null || content === undefined)
      throw new globalThis.Error("The parameter 'content' cannot be null.");
    else content_.append('Content', content.data, content.fileName ? content.fileName : 'Content');
    if (description !== null && description !== undefined)
      content_.append('Description', description.toString());

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/octet-stream',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateInfoDocument(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateInfoDocument(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse | null>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse | null>;
        })
      );
  }

  protected processCreateInfoDocument(response: HttpResponseBase): Observable<FileResponse | null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Deletes an informational document.
     * @param id (optional) ID of the document to delete.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  delete(id: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/info/documents?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Retrieves a list of available informational documents.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  getInfoDocuments(): Observable<ApiInfoDocument[]> {
    let url_ = this.baseUrl + '/api/info/documents';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInfoDocuments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInfoDocuments(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiInfoDocument[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiInfoDocument[]>;
        })
      );
  }

  protected processGetInfoDocuments(response: HttpResponseBase): Observable<ApiInfoDocument[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiInfoDocument[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Retrieves a link where to download content of a document.
     * @param id ID of the document a download link is requested for.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  getDownloadLink(id: string): Observable<string> {
    let url_ = this.baseUrl + '/api/info/documents/{id}/link';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDownloadLink(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDownloadLink(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processGetDownloadLink(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Retrieves the content of an informational document.
     * @param id ID of the document to retrieve.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the
    api action result.
     */
  getContent(id: string): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/info/documents/{id}/download';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContent(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetContent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processGetContent(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IKeepAliveClient {
  /**
   * Endpoint for Azure Web App Keep Alive requests.
   * @return HTTP status NoContent.
   */
  get(): Observable<void>;
}

@Injectable()
export class KeepAliveClient implements IKeepAliveClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Endpoint for Azure Web App Keep Alive requests.
   * @return HTTP status NoContent.
   */
  get(): Observable<void> {
    let url_ = this.baseUrl + '/';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface INotificationClient {
  /**
     * Retrieves a list of notifications for the current user.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  getNotifications(): Observable<ApiGetNotificationsResponse>;
}

@Injectable()
export class NotificationClient implements INotificationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
     * Retrieves a list of notifications for the current user.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  getNotifications(): Observable<ApiGetNotificationsResponse> {
    let url_ = this.baseUrl + '/api/Notification';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotifications(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotifications(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiGetNotificationsResponse>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ApiGetNotificationsResponse>;
        })
      );
  }

  protected processGetNotifications(
    response: HttpResponseBase
  ): Observable<ApiGetNotificationsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiGetNotificationsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IOfferClient {
  /**
   * Completes an offer.
   * @param projectId Id of the project the offer belongs to.
   * @param reason (optional) Text explaining why a final measurement was accepted due to additional positions.
   * @return 204 NoContent if the offer was created successfully.
   */
  complete(projectId: string, reason: string | null | undefined): Observable<void>;
  /**
   * Creates an offer for a project.
   * @param projectId Id of the project the offer belongs to.
   * @param offer Contents of the offer to create.
   * @return 204 NoContent if the offer was created successfully.
   */
  create(projectId: string, offer: ApiOffer): Observable<ApiSaveHintsResponse>;
  /**
   * Retrieves an offer of a project.
   * @param projectId Id of the project the offer belongs to.
   * @return 200 OK or 404 NotFound if no matching offer was found.
   */
  get(projectId: string): Observable<ApiOffer>;
  /**
     * Updates an existing offer.
     * @param projectId Id of the project the offer belongs to.
     * @param offer The offer to update.
     * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or the specified object
    does not exist.
     */
  update(projectId: string, offer: ApiOffer): Observable<ApiSaveHintsResponse>;
  /**
   * Creates an offer pdf for a project.
   * @param projectId Id of the project the offer belongs to.
   * @param offer Contents of the offer to create the pdf for.
   * @return 200 Ok with the pdf file if the offer pdf was created successfully.
   */
  createPdf(projectId: string, offer: ApiOffer): Observable<FileResponse>;
}

@Injectable()
export class OfferClient implements IOfferClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Completes an offer.
   * @param projectId Id of the project the offer belongs to.
   * @param reason (optional) Text explaining why a final measurement was accepted due to additional positions.
   * @return 204 NoContent if the offer was created successfully.
   */
  complete(projectId: string, reason: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/Offer/complete?';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    if (reason !== undefined && reason !== null)
      url_ += 'reason=' + encodeURIComponent('' + reason) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processComplete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processComplete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processComplete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates an offer for a project.
   * @param projectId Id of the project the offer belongs to.
   * @param offer Contents of the offer to create.
   * @return 204 NoContent if the offer was created successfully.
   */
  create(projectId: string, offer: ApiOffer): Observable<ApiSaveHintsResponse> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/Offer';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(offer);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiSaveHintsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiSaveHintsResponse>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<ApiSaveHintsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiSaveHintsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      // Manually patched (see Task-30813): the backend now always returns 200 OK with an
      // ApiSaveHintsResponse body for this operation, never 204 — NSwag cannot model two success
      // status codes on one operation. Treat a 204 as an empty-hints success rather than throwing,
      // as a safety net in case an older backend deployment is still returning it during rollout.
      return _observableOf(null as any as ApiSaveHintsResponse);
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves an offer of a project.
   * @param projectId Id of the project the offer belongs to.
   * @return 200 OK or 404 NotFound if no matching offer was found.
   */
  get(projectId: string): Observable<ApiOffer> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/Offer';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiOffer>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiOffer>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiOffer> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiOffer);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Updates an existing offer.
     * @param projectId Id of the project the offer belongs to.
     * @param offer The offer to update.
     * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or the specified object
    does not exist.
     */
  update(projectId: string, offer: ApiOffer): Observable<ApiSaveHintsResponse> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/Offer';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(offer);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiSaveHintsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiSaveHintsResponse>;
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<ApiSaveHintsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiSaveHintsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      // Manually patched (see Task-30813): the backend now always returns 200 OK with an
      // ApiSaveHintsResponse body for this operation, never 204 — NSwag cannot model two success
      // status codes on one operation. Treat a 204 as an empty-hints success rather than throwing,
      // as a safety net in case an older backend deployment is still returning it during rollout.
      return _observableOf(null as any as ApiSaveHintsResponse);
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Creates an offer pdf for a project.
   * @param projectId Id of the project the offer belongs to.
   * @param offer Contents of the offer to create the pdf for.
   * @return 200 Ok with the pdf file if the offer pdf was created successfully.
   */
  createPdf(projectId: string, offer: ApiOffer): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/Offer/pdf';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(offer);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatePdf(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreatePdf(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processCreatePdf(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IProjectClient {
  /**
     * Accepts an offer request for a project.
     * @param projectId Id of a project to acceppt the offer request for.
     * @param acceptOptions Additional options to use when accepting an offer request.
     * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or there is currently no
                offer requested for the specified project.
     */
  accept(projectId: string, acceptOptions: ApiAcceptProjectRequest): Observable<void>;
  /**
   * Retrieves all projects.
   * @return A list of all available projects.
   */
  getAll(): Observable<ApiProject[]>;
  /**
   * Retrieves a single project with the specified id.
   * @param projectId Id of the project to retrieve.
   * @return A list of all available projects.
   */
  get(projectId: string): Observable<ApiProject>;
  /**
     * Rejects an offer request for a project.
     * @param projectId Id of a project to reject the offer request for.
     * @param rejectOptions Additional options to use when rejecting an offer request.
     * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or there is currently no
                offer requested for the specified project.
     */
  reject(projectId: string, rejectOptions: ApiRejectProjectRequest): Observable<void>;
  /**
   * Cancels a project.
   * @param projectId Id of the project to be cancelled.
   * @param cancelOptions Additional options to use when cancelling a project.
   * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or there is currently no project.
   */
  cancel(projectId: string, cancelOptions: ApiCancelProjectRequest): Observable<void>;
}

@Injectable()
export class ProjectClient implements IProjectClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
     * Accepts an offer request for a project.
     * @param projectId Id of a project to acceppt the offer request for.
     * @param acceptOptions Additional options to use when accepting an offer request.
     * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or there is currently no
                offer requested for the specified project.
     */
  accept(projectId: string, acceptOptions: ApiAcceptProjectRequest): Observable<void> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/accept';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(acceptOptions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAccept(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAccept(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAccept(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves all projects.
   * @return A list of all available projects.
   */
  getAll(): Observable<ApiProject[]> {
    let url_ = this.baseUrl + '/api/Project';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiProject[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiProject[]>;
        })
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<ApiProject[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiProject[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves a single project with the specified id.
   * @param projectId Id of the project to retrieve.
   * @return A list of all available projects.
   */
  get(projectId: string): Observable<ApiProject> {
    let url_ = this.baseUrl + '/api/Project/{projectId}';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiProject>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiProject>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiProject> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiProject);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Rejects an offer request for a project.
     * @param projectId Id of a project to reject the offer request for.
     * @param rejectOptions Additional options to use when rejecting an offer request.
     * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or there is currently no
                offer requested for the specified project.
     */
  reject(projectId: string, rejectOptions: ApiRejectProjectRequest): Observable<void> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/reject';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(rejectOptions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReject(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReject(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processReject(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Cancels a project.
   * @param projectId Id of the project to be cancelled.
   * @param cancelOptions Additional options to use when cancelling a project.
   * @return 204 NoContent if the action was successfull or 400 BadRequest if the provided data was invalid or there is currently no project.
   */
  cancel(projectId: string, cancelOptions: ApiCancelProjectRequest): Observable<void> {
    let url_ = this.baseUrl + '/api/Project/{projectId}/cancel';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(cancelOptions);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCancel(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCancel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCancel(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IReleaseOrderCompanyClient {
  /**
   * Retrieves a list of available contacts for release orders.
   * @param projectId Id of the project to retrieve available release oder contacts for.
   * @return A list of available contacts for a release order of the specified project.
   */
  get(projectId: string): Observable<ReleaseOrderCompany[]>;
}

@Injectable()
export class ReleaseOrderCompanyClient implements IReleaseOrderCompanyClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Retrieves a list of available contacts for release orders.
   * @param projectId Id of the project to retrieve available release oder contacts for.
   * @return A list of available contacts for a release order of the specified project.
   */
  get(projectId: string): Observable<ReleaseOrderCompany[]> {
    let url_ = this.baseUrl + '/api/project/{projectId}/releaseOrderCompanies';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseOrderCompany[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseOrderCompany[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ReleaseOrderCompany[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ReleaseOrderCompany[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IReleaseOrderClient {
  /**
   * Creates release order data for pdf.
   * @param projectId Id of the project for which a release order should be created.
   * @param releaseOrder Contents of the releaseorder to create.
   * @return 200 Ok if the release order pdf was created successfully.
   */
  create(projectId: string, releaseOrder: ApiReleaseOrder): Observable<FileResponse>;
}

@Injectable()
export class ReleaseOrderClient implements IReleaseOrderClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Creates release order data for pdf.
   * @param projectId Id of the project for which a release order should be created.
   * @param releaseOrder Contents of the releaseorder to create.
   * @return 200 Ok if the release order pdf was created successfully.
   */
  create(projectId: string, releaseOrder: ApiReleaseOrder): Observable<FileResponse> {
    let url_ = this.baseUrl + '/api/project/{projectId}/releaseorder';
    if (projectId === undefined || projectId === null)
      throw new globalThis.Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace('{projectId}', encodeURIComponent('' + projectId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(releaseOrder);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IRoleClient {
  /**
   * Retrieves a list of all available roles.
   * @return A list of all available roles.
   */
  get(): Observable<ApiRole[]>;
}

@Injectable()
export class RoleClient implements IRoleClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Retrieves a list of all available roles.
   * @return A list of all available roles.
   */
  get(): Observable<ApiRole[]> {
    let url_ = this.baseUrl + '/api/Role';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiRole[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiRole[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiRole[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiRole[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IUserClient {
  /**
   * Retrieves all users of a general contractor.
   * @return A list of all users assigned to a general contractor.
   */
  getAll(): Observable<ApiUser[]>;
  /**
   * Retrieves the user information for the calling user.
   * @return The user object of the calling user. 400 if no userId is found in the token. 404 if no user is found for the specified id
   */
  get(): Observable<ApiUser>;
  /**
   * Updates only mobile phone number of the acting user.
   * @param mobile (optional) MobilePhone number to assign to user
   * @return 204 NoContent on success. 400 if no userId is found in the token. 404 NotFound if no user with the specified id exists.
   */
  update(mobile: string | undefined): Observable<void>;
  /**
   * Assigns a user a role.
   * @param userId Id of the user the role should be granted.
   * @param roleId Id of the role that should be granted.
   * @return 204 NoContent on success. 404 NotFound if no user with the specified id exists.
   */
  grantRole(userId: string, roleId: string): Observable<void>;
  /**
   * Removes a single user role.
   * @param userId Id of the user the role should be removed.
   * @param roleId Id of the role that should be removed.
   * @return 204 NoContent on success. 404 NotFound if no user with the specified id exists.
   */
  removeRole(userId: string, roleId: string): Observable<void>;
  /**
   * Updates a User State to become Locked.
   * @param userId Id of the user which should be updated for user state.
   * @return 204 NoContent on success. 404 NotFound if no user with the specified id exists.
   */
  lockUser(userId: string): Observable<void>;
  /**
   * Updates a User State to become UnLocked.
   * @param userId Id of the user which should be updated for user state.
   * @return 204 NoContent on success. 404 NotFound if no user with the specified id exists.
   */
  unLockUser(userId: string): Observable<void>;
}

@Injectable()
export class UserClient implements IUserClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
   * Retrieves all users of a general contractor.
   * @return A list of all users assigned to a general contractor.
   */
  getAll(): Observable<ApiUser[]> {
    let url_ = this.baseUrl + '/api/User';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiUser[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiUser[]>;
        })
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<ApiUser[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiUser[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves the user information for the calling user.
   * @return The user object of the calling user. 400 if no userId is found in the token. 404 if no user is found for the specified id
   */
  get(): Observable<ApiUser> {
    let url_ = this.baseUrl + '/api/User/self';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiUser>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiUser>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiUser> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiUser);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates only mobile phone number of the acting user.
   * @param mobile (optional) MobilePhone number to assign to user
   * @return 204 NoContent on success. 400 if no userId is found in the token. 404 NotFound if no user with the specified id exists.
   */
  update(mobile: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/User/self?';
    if (mobile === null) throw new globalThis.Error("The parameter 'mobile' cannot be null.");
    else if (mobile !== undefined) url_ += 'mobile=' + encodeURIComponent('' + mobile) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Assigns a user a role.
   * @param userId Id of the user the role should be granted.
   * @param roleId Id of the role that should be granted.
   * @return 204 NoContent on success. 404 NotFound if no user with the specified id exists.
   */
  grantRole(userId: string, roleId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/User/{userId}/roles/{roleId}';
    if (userId === undefined || userId === null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (roleId === undefined || roleId === null)
      throw new globalThis.Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGrantRole(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGrantRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processGrantRole(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result409
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Removes a single user role.
   * @param userId Id of the user the role should be removed.
   * @param roleId Id of the role that should be removed.
   * @return 204 NoContent on success. 404 NotFound if no user with the specified id exists.
   */
  removeRole(userId: string, roleId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/User/{userId}/roles/{roleId}';
    if (userId === undefined || userId === null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (roleId === undefined || roleId === null)
      throw new globalThis.Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveRole(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRemoveRole(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates a User State to become Locked.
   * @param userId Id of the user which should be updated for user state.
   * @return 204 NoContent on success. 404 NotFound if no user with the specified id exists.
   */
  lockUser(userId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/User/{userId}/lock';
    if (userId === undefined || userId === null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLockUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLockUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processLockUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates a User State to become UnLocked.
   * @param userId Id of the user which should be updated for user state.
   * @return 204 NoContent on success. 404 NotFound if no user with the specified id exists.
   */
  unLockUser(userId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/User/{userId}/unlock';
    if (userId === undefined || userId === null)
      throw new globalThis.Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnLockUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnLockUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUnLockUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IUserRegistrationClient {
  /**
     * Accepts an existing user registration.
     * @param id Id of the user registration to accept.
     * @param options (optional) Additional options when accepting a user registration.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  accept(id: string, options: ApiAcceptUserRegistrationRequest | undefined): Observable<void>;
  /**
     * Creates a new user registration.
     * @param userRegistrationRequest Content of the user registration to create.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  create(userRegistrationRequest: ApiCreateUserRegistrationRequest): Observable<void>;
  /**
     * Retrieves all user registrations to related gu-Id.
     * @param generalContractorId (optional) Id of the requested generalContractorId.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  getAll(generalContractorId: string | undefined): Observable<ApiUserRegistration[]>;
  /**
     * Creates a new user registration.
     * @param generalContractorId (optional) ID of the general contractor the user should be assigned to.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  createForExistingUser(generalContractorId: string | undefined): Observable<void>;
  /**
     * Retrieves a single user registration.
     * @param id Id of the requested user registration.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  get(id: string): Observable<ApiUserRegistration>;
  /**
   * Retrieves the configured password requirements.
   * @return An object containing requirements for secure passwords.
   */
  getPasswordRequirements(): Observable<PasswordRequirements>;
  /**
     * Rejects an existing user registration.
     * @param id Id of the user registration to accept.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  reject(id: string): Observable<void>;
}

@Injectable()
export class UserRegistrationClient implements IUserRegistrationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ?? 'https://localhost:5001';
  }

  /**
     * Accepts an existing user registration.
     * @param id Id of the user registration to accept.
     * @param options (optional) Additional options when accepting a user registration.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  accept(id: string, options: ApiAcceptUserRegistrationRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserRegistration/{id}/accept';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(options);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAccept(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAccept(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAccept(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Creates a new user registration.
     * @param userRegistrationRequest Content of the user registration to create.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  create(userRegistrationRequest: ApiCreateUserRegistrationRequest): Observable<void> {
    let url_ = this.baseUrl + '/api/UserRegistration';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(userRegistrationRequest);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result409
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Retrieves all user registrations to related gu-Id.
     * @param generalContractorId (optional) Id of the requested generalContractorId.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  getAll(generalContractorId: string | undefined): Observable<ApiUserRegistration[]> {
    let url_ = this.baseUrl + '/api/UserRegistration?';
    if (generalContractorId === null)
      throw new globalThis.Error("The parameter 'generalContractorId' cannot be null.");
    else if (generalContractorId !== undefined)
      url_ += 'generalContractorId=' + encodeURIComponent('' + generalContractorId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiUserRegistration[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiUserRegistration[]>;
        })
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<ApiUserRegistration[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiUserRegistration[]);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Creates a new user registration.
     * @param generalContractorId (optional) ID of the general contractor the user should be assigned to.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  createForExistingUser(generalContractorId: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/UserRegistration/self?';
    if (generalContractorId === null)
      throw new globalThis.Error("The parameter 'generalContractorId' cannot be null.");
    else if (generalContractorId !== undefined)
      url_ += 'generalContractorId=' + encodeURIComponent('' + generalContractorId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateForExistingUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateForExistingUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreateForExistingUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result409
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Retrieves a single user registration.
     * @param id Id of the requested user registration.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  get(id: string): Observable<ApiUserRegistration> {
    let url_ = this.baseUrl + '/api/UserRegistration/{id}';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApiUserRegistration>;
            }
          } else return _observableThrow(response_) as any as Observable<ApiUserRegistration>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiUserRegistration> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApiUserRegistration);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieves the configured password requirements.
   * @return An object containing requirements for secure passwords.
   */
  getPasswordRequirements(): Observable<PasswordRequirements> {
    let url_ = this.baseUrl + '/api/UserRegistration/passwordRequirements';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPasswordRequirements(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPasswordRequirements(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PasswordRequirements>;
            }
          } else return _observableThrow(response_) as any as Observable<PasswordRequirements>;
        })
      );
  }

  protected processGetPasswordRequirements(
    response: HttpResponseBase
  ): Observable<PasswordRequirements> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as PasswordRequirements);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Rejects an existing user registration.
     * @param id Id of the user registration to accept.
     * @return A task that represents the asynchronous operation. The value of its Result property contains the api
    action result.
     */
  reject(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/UserRegistration/{id}/reject';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReject(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReject(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processReject(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface ProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

/** Address for any location. */
export interface ApiAddress {
  /** Name of the city. */
  city?: string | undefined;
  /** Number/Name of the parcel. */
  parcel?: string | undefined;
  /** Postal code / Zip Code */
  postalCode?: string | undefined;
  /** Name of the street including a house number. */
  street?: string | undefined;
  /** Type of the address. */
  type: AddressType;
}

/** Postal address with a recipient or sender. */
export interface ApiPostalAddress extends ApiAddress {
  /** Firt line of the recipient or sender name. */
  company1: string;
  /** Second line of the recipient or sender name. */
  company2?: string | undefined;
  /** Third line of the recipient or sender name. */
  company3?: string | undefined;
}

/** A delivery address for call orders. */
export interface ApiDeliveryAddress extends ApiPostalAddress {
  /** An alias for easier selection. */
  alias: string;
  /** Unique id of the entity. */
  id?: string | undefined;
}

/** Type of address. */
export enum AddressType {
  Company = 0,
  Delivery = 1,
  Invoice = 2,
}

/** A document. */
export interface Document {
  /** Date and time when the document was created. */
  createdAt: Date;
  /** Name of the file. */
  fileName: string;
  /** Id of the document. */
  id: string;
  /** Type of the document. */
  type: string;
  /** Description of the document type. */
  typeDescription?: string | undefined;
}

/** A mandatory document for a project. */
export interface ApiMandatoryDocument {
  /** Indicates if a file is uploaded for the documentType. */
  isUploaded: boolean;
  /** Type of the document. */
  type: string;
}

/** Represents an equipment. */
export interface Equipment {
  /** Eqipmentclass. */
  class: string;
  /** Age limit in years for the equipment class. If an existing equipment of the same class
is younger than this threshold, a justification must be provided before saving. */
  ageLimit?: number | undefined;
  /** Year when the equipment was build. */
  constructionYear?: number | undefined;
  /** Indicates whether the equipment should be dismantled. */
  dismantling?: boolean | undefined;
  /** Name of the equipments manufacturer. */
  manufacturer: string;
  /** Serial number assigned by the manufacturer. */
  manufacturerSerialNumber?: string | undefined;
  /** A short description of the equipment. */
  name: string;
  /** Unique number of the equipment. */
  number: string;
  /** Numer of modules installed. */
  numberOfModules?: number | undefined;
  /** Status of the equipment. */
  status: string;
  /** Type of the equipement. */
  type: string;
  /** Service number of the equipment. */
  serviceNumber: string;
  /** TypeDescription of the equipment. */
  typeDescription: string;
  /** Begründung für die vorzeitige Neuanlage dieses Equipments, sofern ein Bestands-Equipment
derselben Klasse den definierten Altersgrenzwert noch nicht erreicht hat. Wird an SAP via
ZGU_ESM_EQSAVE als Lltext des Equipments übergeben. Maximale Länge: 1.000 Zeichen. */
  ageJustification?: string | undefined;
}

/** Request model for updating a list of equipments. */
export interface ApiEquipmentUpdateRequest {
  /** The list of equipments to update. Newly created ("NEU") equipments carry their own
ageJustification when required. */
  equipments: Equipment[];
}

/** Response body for a save endpoint (200 OK) carrying one or more non-blocking, purely informational hints. Does not indicate an error; the save operation completed successfully. */
export interface ApiSaveHintsResponse {
  /** The hints raised for this save operation. Never empty — an endpoint returns 204 NoContent instead
of this response when there is nothing to report. */
  hints: ApiSaveHint[];
}

/** A single non-blocking, purely informational hint returned as part of an ApiSaveHintsResponse with 200 OK (instead of 204 NoContent) from a save endpoint. Does not indicate an error; the save operation completed successfully regardless of any hints present. */
export interface ApiSaveHint {
  /** A short, stable machine-readable category for this hint. */
  type: string;
  /** A short, human-readable summary of the hint. */
  title: string;
  /** The HTTP status code of the response this hint is attached to. Always 200, since hints are
non-blocking and the save operation succeeded. */
  status: number;
  /** A stable machine-readable code identifying this specific kind of hint, for programmatic handling by the frontend. */
  code: string;
  /** A human-readable explanation of the hint. */
  detail: string;
  /** Additional structured details about the hint, specific to its Code. */
  meta?: { [key: string]: any } | undefined;
}

/** Represents an offer or final measurement. */
export interface ApiOffer {
  /** Gets positions of an offer. */
  positions: ApiOfferPosition[];
  /** Gets or sets the timestamp when the offer was first created. */
  createdAt?: Date | undefined;
}

/** A position of an offer or final agreement. */
export interface ApiOfferPosition {
  /** Text to describe or justify the position. */
  descriptionText?: string | undefined;
  /** Number of the general agreement the service comes from. */
  generalAgreementNumber?: string | undefined;
  /** Number of the general agreement position. */
  generalAgreementPosition?: string | undefined;
  /** Value indicating whether a check is required. */
  isCheckRequired?: boolean | undefined;
  /** Value indicating whether the node is a special service. */
  isSpecial?: boolean | undefined;
  /** Number of units to bill. */
  quantity: number;
  /** Abbreviation of the quantity unit. */
  quantityUnit?: string | undefined;
  /** Number of the service billed. */
  serviceNumber: string;
  /** Short description of the service. */
  serviceText: string;
  /** Type of service RV=general agreement position, ABRUF=call order position, FREE=custom service. */
  type?: string | undefined;
  /** Price of a single unit. */
  unitPrice: number;
  /** Indicator for air conditioning/ventilation system */
  sonkz?: string | undefined;
  /** Gets or sets a value indicating whether the position describes a dismantling (Demontage). */
  isDismantling?: boolean | undefined;
}

/** A node in a hierarchy of a general agreement. */
export interface ApiGeneralAgreementNode {
  /** Number of the general agreement. */
  contractNumber?: string | undefined;
  /** Positionnumer from the general agreement. */
  generalAgreementPosition?: string | undefined;
  /** Gets a value indicating whether the node represents a group. */
  isGroup: boolean;
  /** Gross price for a single service. */
  grossPrice?: number | undefined;
  /** Gets a value indicating whether a check is required. */
  isCheckRequired?: boolean | undefined;
  /** Gets a value indicating whether the node is a special service. */
  isSpecial?: boolean | undefined;
  /** Gets a value indicating the maximal quantity that may be specified. */
  maxQuantity?: number | undefined;
  /** Get a list of service numbers this service may not be combined with. */
  noCombination: string[];
  /** Number of a service. */
  number: string;
  /** Predefined quantity. */
  quantity?: number | undefined;
  /** Quantity unit for a service. */
  quantityUnit?: string | undefined;
  /** Short description of the service. */
  text: string;
  /** Type of service RV=general agreement position, ABRUF=call order position, FREE=custom service. */
  type?: string | undefined;
  /** Sub nodes of a group or null for a service. */
  nodes?: ApiGeneralAgreementNode[] | undefined;
  /** MaxAmount for handlingfees. */
  maxAmount?: number | undefined;
  /** percentage value for handlingfees. */
  percentage: number;
  /** Indicator for air conditioning/ventilation system */
  sonkz?: string | undefined;
  /** Gets a value indicating whether the service position describes a dismantling (Demontage). */
  isDismantling?: boolean | undefined;
  /** Equipment class (Eqklasse) this service position implies, if any. */
  equipmentClass?: string | undefined;
}

/** A general contractor. (GU) */
export interface GeneralContractor {
  /** ID / Number of a general contractor. */
  id: string;
  /** Name of the general contractor. */
  name: string;
}

/** Represents a document in the public info mail box. */
export interface ApiInfoDocument {
  /** Date and time when a document was uploaded. */
  createDate: Date;
  /** Description. */
  description?: string | undefined;
  /** Original name of the uploaded file. */
  filename: string;
  /** Id of a document. */
  id: string;
  /** MIME type of a document. */
  mimeType?: string | undefined;
  /** File size in byte. */
  size: number;
}

/** Response to a GetNotifications request. */
export interface ApiGetNotificationsResponse {
  /** A list of notifications for the current user. */
  notifications: string[];
}

/** Request to accept an offer request. */
export interface ApiAcceptProjectRequest {
  /** Contact information of the responsible contact. */
  responsibleProcessor: ApiCombinedNameContact;
}

/** Contact information. */
export interface ApiCombinedNameContact {
  /** Email address. */
  email?: string | undefined;
  /** Surname and given name. */
  name?: string | undefined;
  /** Phone number. */
  phone?: string | undefined;
}

/** A project. (Vorhaben) */
export interface ApiProject {
  /** Address of the project. */
  address: ApiAddress;
  /** Actual date of offer. */
  biddingActual?: Date | undefined;
  /** Budget value. */
  budgetValue?: number | undefined;
  /** Actual handover date of construction contract. */
  buildingContractHandoverActual?: Date | undefined;
  /** Actual date of building handover. */
  buildingHandoverActual?: Date | undefined;
  /** Planned date for building handover. */
  buildingHandoverPlan?: Date | undefined;
  /** Planned completion date. */
  completionPlan?: Date | undefined;
  /** Actual begin of construction work. */
  constructionBeginReadyActual?: Date | undefined;
  /** The DFMG-ID. */
  dfmgId?: string | undefined;
  /** Actual date of EP handover. */
  epHandoverActual?: Date | undefined;
  /** The expansion year. */
  expansionYear?: number | undefined;
  /** External project number (60????????/01). */
  externalProjectNumber: string;
  /** Date the final measurement (Schlussaufmaß) was handed over. */
  finalMeasurementHandoverDate?: Date | undefined;
  /** Date the final measurement (Schlussaufmaß) was released. */
  finalMeasurementReleaseDate?: Date | undefined;
  /** Functional location number. */
  functionalLocation?: string | undefined;
  /** Project id or number. */
  id: string;
  /** Total value of the invoice. */
  invoiceValue?: number | undefined;
  /** Name of the location. */
  locationName?: string | undefined;
  /** Total value of the measurement. */
  measurementValue?: number | undefined;
  /** Date when the offer was completed. */
  offerHandoverDate?: Date | undefined;
  /** Description of why an offer request was rejected or why a final measurement was accepted due to additional positions. */
  reasoningText?: string | undefined;
  /** Order number. */
  orderNumber?: string | undefined;
  /** Value of the order. */
  orderValue?: number | undefined;
  /** PASM project number. */
  pasmProjectNumber?: string | undefined;
  /** Type of process. (Bau mit/ohne DFMG) */
  processType: string;
  /** Type of the project. (Neubau/Umbau) */
  program: string;
  /** Short description of a project. */
  projectName: string;
  /** Actual date of release for construction. */
  releaseActual?: Date | undefined;
  /** Responsible project contact from the general contractor. */
  responsibleProcessor?: ApiCombinedNameContact | undefined;
  /** Current status of the project. */
  status: string;
  /** TD Location ID. */
  tdLocationId?: string | undefined;
  /** Cancellation option indicator: "X" = Cancellation possible */
  cancellationPossible?: string | undefined;
}

/** Request to reject an offer request. */
export interface ApiRejectProjectRequest {
  /** A description why the offer request is rejected. */
  reason: string;
}

/** Request to cancel a project. */
export interface ApiCancelProjectRequest {
  /** Reason for the initiated cancellation */
  cancellationReason: string;
}

/** Base class for release order information. */
export interface ReleaseOrderPartner {
  /** Address of the business partner. */
  address?: Address | undefined;
  /** Description of the business partner. */
  description?: string | undefined;
  /** Email address. */
  email?: string | undefined;
  /** Fax number. */
  fax?: string | undefined;
  /** Unique id for storage in relational databases.
Initialized with guid cause FE should not care for it. */
  id: string;
  /** Name of the business partner. */
  name?: string | undefined;
  /** Telephone number. */
  phone?: string | undefined;
}

/** A company usable for release orders. */
export interface ReleaseOrderCompany extends ReleaseOrderPartner {
  /** Available contact persons. */
  contacts: ReleaseOrderContact[];
  /** Number of the general agreement. */
  contractNumber: string;
  /** ID of a project for which the companies are available. */
  projectId: string;
}

/** Contact for a release order. */
export interface ReleaseOrderContact extends ReleaseOrderPartner {
  /** Unique number of a contact within a company. */
  number: number;
}

/** Address for any location. */
export interface Address {
  /** Name of the city. */
  city?: string | undefined;
  /** Id of the general contractor the entity belongs to. */
  generalContractorId: string;
  /** Unique id of the entity. */
  id: string;
  /** Number/Name of the parcel. */
  parcel?: string | undefined;
  /** Postal code / Zip Code */
  postalCode?: string | undefined;
  /** Name of the street including a house number. */
  street?: string | undefined;
  /** Type of the address. */
  type?: AddressType | undefined;
}

/** Holds all Release-Order-information. */
export interface ApiReleaseOrder {
  /** General Contractor which requests the order. */
  requestOrderCompany: string;
  /** Release ordername which relies to the order. */
  releaseOrderName: string;
  /** The deliverydate for the order. */
  deliveryDate?: Date | undefined;
  /** Flag for setting Invoice-Address same as Company-Address. */
  companyAddressIsInvoiceAddress?: boolean | undefined;
  /** Flag for setting Delivery-Address same as Company-Address. */
  companyAddressIsDeliveryAddress?: boolean | undefined;
  /** Gets positions of an order. */
  positions: ApiOfferPosition[];
  /** Gets ReleaseToCompanyAddress. */
  releaseToCompanyAddress?: ApiOrderAddress | undefined;
  /** Gets ReleaseToCompanyAddress Address. */
  releaseFromCompanyAddress?: ApiOrderAddress | undefined;
  /** Gets Company Address- means ASP-Fields to fill. */
  companyContact?: ApiOrderContact | undefined;
  /** Gets Order-Invoice-Address. */
  orderInvoiceAddress?: ApiOrderAddress | undefined;
  /** Gets Order-Delivery-Address. */
  orderDeliveryAddress?: ApiOrderAddress | undefined;
  /** Gets Company Contact like Name-Tel-Fax-Mobile-Mail. */
  releaseFromContact?: ReleaseContact | undefined;
  /** Gets main Release Contact name, and Contact-Descriptors. */
  releaseContact?: ReleaseContact | undefined;
  /** Gets a list of ReleaseToContacts with Contact-Descriptors. */
  releaseContacts?: ReleaseContact[] | undefined;
}

/** Address for the requester-company. */
export interface ApiOrderAddress {
  /** The name of the company. */
  company1?: string | undefined;
  /** Second line of the recipient or sender name. */
  company2?: string | undefined;
  /** Third line of the recipient or sender name. */
  company3?: string | undefined;
  /** Postal code. */
  postalCode?: string | undefined;
  /** City name. */
  city?: string | undefined;
  /** Name of the street including a house number. */
  street?: string | undefined;
}

export interface ApiOrderContact {
  /** ContactName Order Contact. */
  contactName: string;
  /** Phone number to OrderTo-Contact. */
  phone: string;
  /** Mobil number to OrderTo-Contact. */
  mobil?: string | undefined;
  /** Email to OrderTo-Contact. */
  email?: string | undefined;
}

/** ReleaseTo Contact-Informations. */
export interface ReleaseContact {
  /** Name of contact. */
  contactName?: string | undefined;
  /** Phone for Contact. */
  phone?: string | undefined;
  /** Faxno for Contact. */
  fax?: string | undefined;
  /** Mobile-No for Contact. */
  mobil?: string | undefined;
  /** Email for Contact. */
  email?: string | undefined;
}

/** A security role. */
export interface ApiRole {
  /** Unique id of the role. */
  id: string;
  /** Name of the role. */
  name: string;
}

/** A user. */
export interface ApiUser {
  /** Email address of the user. */
  email: string;
  /** Unique id of the user. */
  id: string;
  /** Given name(s) of the user. */
  givenName: string;
  /** Mobile phone number of the user. */
  mobilePhone: string;
  /** A list of roles assigned to the user. */
  roles: string[];
  /** Surname of the user. */
  surname: string;
  /** User State- NotLocked = 0, LockedByInactivity = 1, LockedByAdmin= 2. */
  userState: number;
}

/** Options for accepting a user registration. */
export interface ApiAcceptUserRegistrationRequest {
  /** A list of role id's the that should be assigned to the user. */
  roles: string[];
}

/** A request to register a user. */
export interface ApiUserRegistration {
  /** User Email. */
  email: string;
  /** Gu-Id. */
  generalContractorId: string;
  /** User-Given-Name. */
  givenName: string;
  /** User-Mobil-No. */
  mobilePhone: string;
  /** User-SurName. */
  surname: string;
}

/** A request to create a new user registration. */
export interface ApiCreateUserRegistrationRequest extends ApiUserRegistration {
  /** The password requested by the user. */
  desiredPassword: string;
  /** Number of the general contractor the user should be assigned to. */
  generalContractorId: string;
}

/** Requirements for secure passwords. */
export interface PasswordRequirements {
  /** Maximum allowed length of a password. The default value is 256. */
  maxLength: number;
  /** Minimum number of digits required. The default value is 1. */
  minDigits: number;
  /** Minimum allowed length of a password. The default value is 12. */
  minLength: number;
  /** Minimum number of lower case characters required. The default value is 1. */
  minLowerCaseChars: number;
  /** Minimum number of special characters (symbol or punctuation) required. The default value is 1. */
  minSpecialChars: number;
  /** Minimum number of upper case characters required. The default value is 1. */
  minUpperCaseChars: number;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
